/**
 * Tab paging direction (SCREENS.md "Tab paging").
 *
 * The slide direction has to be known BEFORE the navigation starts, because React Router hands the
 * DOM update straight to `document.startViewTransition` and the keyframes are chosen by a CSS
 * attribute selector on the root element. So this is set synchronously from the tab's own click
 * handler, not from an effect after the location has already changed.
 *
 * Direction is the tab ORDER, never history: tapping Bag from World slides the same way however
 * you got to World. A back/forward gesture is not a tab tap and does not page at all.
 */
export type NavDirection = 'forward' | 'back' | 'none';

export function navDirection(from: number, to: number): NavDirection {
  if (from === to) return 'none';
  // No tab owns the current route (a land, a profile, a sheet). There is no ordering to mirror,
  // and guessing one reads as a glitch, so these always page forward.
  if (from < 0) return 'forward';
  return to > from ? 'forward' : 'back';
}

export function setNavDirection(from: number, to: number): void {
  document.documentElement.dataset.navDir = navDirection(from, to);
}

/** Hub-pin → land dissolve (SCREENS.md `/world` map). Must run before `navigate({ viewTransition })`
 *  so the tab-paging slide keyframes do not fire on a leftover `data-nav-dir`. */
export function setLandDissolve(): void {
  document.documentElement.dataset.navDir = 'land';
}
